import { useContext } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import ConditionalWrapper from 'utils/ConditionalWrapper';
import { StyleContext } from 'utils/context/StyleContextProvider';
import Image from 'components/Layout/Module/Image';
import format from 'date-fns/format';
import { CD_BLOG_CATEGORIES, VLS_BLOG_CATEGORIES } from 'utils/constants';

export default function BlogArticle({ blog, isLink = true, isHero, section }) {
    const styles = useContext(StyleContext),
        articleCategory = blog?.category,
        date = blog?.date,
        authors = blog?.authorCollection?.items;

    let blogPath = '/blog/';

    if (CD_BLOG_CATEGORIES.includes(articleCategory?.slug)) {
        blogPath = 'https://cancerdetect.viome.com/resources/';
    }
    if (VLS_BLOG_CATEGORIES.includes(articleCategory?.slug)) {
        blogPath = `https://www.viomelifesciences.com/blog/category/${articleCategory?.slug}/`;
    }

    return (
        <ConditionalWrapper
            condition={isLink}
            wrapper={(nodeChildData) => (
                <Link
                    href={`${blogPath}${blog?.slug}`}
                    className={classNames(
                        styles.article,
                        isHero && styles.hero,
                    )}
                >
                    {nodeChildData}
                </Link>
            )}
        >
            <div
                className={classNames(
                    isHero && `lg:grid lg:grid-cols-2`,
                    styles.wrapper,
                )}
            >
                <div className={styles.image}>
                    <div className={styles['image--zoom']}>
                        {blog?.featuredImage && (
                            <Image
                                data={blog?.featuredImage}
                                options={{ layout: 'fill' }}
                            />
                        )}
                    </div>
                </div>
                <div className={styles.body}>
                    <div className={styles.meta}>
                        <p className={classNames('uppercase', styles.category)}>
                            {section && date ? (
                                <time dateTime={date}>
                                    {format(new Date(date), 'LLLL d, yyyy')}
                                </time>
                            ) : (
                                blog?.category?.title
                            )}
                        </p>
                        <p className={classNames('heading-4', styles.title)}>
                            {blog?.title}
                        </p>
                        {section ? (
                            <p className={classNames(styles.author)}>
                                {authors && authors[0].name}
                            </p>
                        ) : (
                            <p className={classNames(styles.subtitle)}>
                                {blog?.subtitle}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </ConditionalWrapper>
    );
}
